import AccountBoxIcon from "@material-ui/icons/AccountBox";
import AddIcon from "@material-ui/icons/Add";
import ViewCarousel from "@material-ui/icons/AmpStoriesRounded";
import ArrowBack from "@material-ui/icons/ArrowBack";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowForward from "@material-ui/icons/ArrowForward";
import Block from "@material-ui/icons/Block";
import Cancel from "@material-ui/icons/Cancel";
import Cast from "@material-ui/icons/Cast";
import CastConnected from "@material-ui/icons/CastConnected";
import ChatOutlinedIcon from "@material-ui/icons/ChatOutlined";
import Check from "@material-ui/icons/Check";
import CheckCircle from "@material-ui/icons/CheckCircle";
import Close from "@material-ui/icons/Close";
import Create from "@material-ui/icons/Create";
import Delete from "@material-ui/icons/Delete";
import DesktopAccessDisabled from "@material-ui/icons/DesktopAccessDisabledOutlined";
import DesktopWindows from "@material-ui/icons/DesktopWindowsOutlined";
import Done from "@material-ui/icons/Done";
import Draft from "@material-ui/icons/DonutLargeOutlined";
import DragIndicator from "@material-ui/icons/DragIndicator";
import EmailIcon from "@material-ui/icons/Email";
import Emoji from "@material-ui/icons/EmojiEmotions";
import Error from "@material-ui/icons/Error";
import { default as ExitToApp, default as ExitToAppIcon } from "@material-ui/icons/ExitToApp";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FaceIcon from "@material-ui/icons/Face";
import Favorite from "@material-ui/icons/Favorite";
import FavoriteBorder from "@material-ui/icons/FavoriteBorder";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import FileCopyOutlined from "@material-ui/icons/FileCopyOutlined";
import EquipmentIcon from "@material-ui/icons/FitnessCenter";
import Fullscreen from "@material-ui/icons/Fullscreen";
import FullscreenExit from "@material-ui/icons/FullscreenExit";
import FullscreenOutlined from "@material-ui/icons/FullscreenOutlined";
import GridOn from "@material-ui/icons/GridOnOutlined";
import Group from "@material-ui/icons/Group";
import Info from "@material-ui/icons/InfoOutlined";
import InsertEmoticonIcon from "@material-ui/icons/InsertEmoticon";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Language from "@material-ui/icons/Language";
import Link from "@material-ui/icons/Link";
import ViewList from "@material-ui/icons/ListRounded";
import Menu from "@material-ui/icons/Menu";
import Message from "@material-ui/icons/Message";
import MicNoneOutlined from "@material-ui/icons/MicNoneRounded";
import MicMuted from "@material-ui/icons/MicOffRounded";
import MicOutlined from "@material-ui/icons/MicRounded";
import MoreHoriz from "@material-ui/icons/MoreHoriz";
import MoreVert from "@material-ui/icons/MoreVert";
import MusicNoteOutlined from "@material-ui/icons/MusicNoteOutlined";
import NotificationsActive from "@material-ui/icons/NotificationsActive";
import NotificationsNone from "@material-ui/icons/NotificationsNone";
import PermIdentity from "@material-ui/icons/PermIdentity";
import { default as PersonAdd, default as PersonAddIcon } from "@material-ui/icons/PersonAdd";
import PhoneIcon from "@material-ui/icons/Phone";
import PlayArrow from "@material-ui/icons/PlayArrow";
import Publish from "@material-ui/icons/Publish";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
import Receipt from "@material-ui/icons/ReceiptRounded";
import VoiceOver from "@material-ui/icons/RecordVoiceOverOutlined";
import Redo from "@material-ui/icons/Redo";
import Reorder from "@material-ui/icons/ReorderOutlined";
import Schedule from "@material-ui/icons/Schedule";
import Search from "@material-ui/icons/Search";
import Send from "@material-ui/icons/Send";
import Settings from "@material-ui/icons/Settings";
import Share from "@material-ui/icons/Share";
import Star from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import Stars from "@material-ui/icons/Stars";
import Stop from "@material-ui/icons/Stop";
import ThumbUp from "@material-ui/icons/ThumbUp";
import DurationIcon from "@material-ui/icons/TimerOutlined";
import Tune from "@material-ui/icons/TuneOutlined";
import Undo from "@material-ui/icons/Undo";
import UnfoldLess from "@material-ui/icons/UnfoldLess";
import UnfoldMore from "@material-ui/icons/UnfoldMore";
import VideocamOutlined from "@material-ui/icons/VideocamOutlined";
import ViewAgenda from "@material-ui/icons/ViewAgenda";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import VoiceOverOff from "@material-ui/icons/VoiceOverOffOutlined";
import VolumeDown from "@material-ui/icons/VolumeDown";
import VolumeMute from "@material-ui/icons/VolumeMute";
import VolumeOff from "@material-ui/icons/VolumeOff";
import VolumeUp from "@material-ui/icons/VolumeUp";
import Warning from "@material-ui/icons/Warning";
import Calendar from "@material-ui/icons/WatchLaterOutlined";
import IosShareIcon from "./Icons/IosShare";
import KvixKoin from "./Icons/KvixKoin";
import TiktokIcon from "./Icons/Tiktok";
export const KvixIcon = {
    Heart: {
        Empty: FavoriteBorder,
        Filled: Favorite
    },
    Menu: {
        Hamburger: Menu,
        Dots: MoreHoriz
    },
    More: {
        Horizontal: MoreHoriz,
        Vertical: MoreVert
    },
    Chevron: {
        Left: KeyboardArrowLeft,
        Right: KeyboardArrowRight,
        Down: KeyboardArrowDown,
        Up: KeyboardArrowUpIcon
    },
    Checkmark: {
        Simple: Check,
        Circled: CheckCircle
    },
    Arrow: {
        Forward: ArrowForward,
        Down: ArrowDownward,
        Back: ArrowBack
    },
    DropArrow: {
        Up: ArrowDropUpIcon,
        Down: ArrowDropDownIcon
    },
    Unfold: {
        More: UnfoldMore,
        Less: UnfoldLess
    },
    Fullscreen: {
        Enter: Fullscreen,
        Exit: FullscreenExit
    },
    Volume: {
        Disabled: VolumeOff,
        Low: VolumeMute,
        Medium: VolumeDown,
        High: VolumeUp
    },
    Eye: {
        Visible: Visibility,
        Hidden: VisibilityOff
    },
    History: {
        Undo,
        Redo
    },
    View: {
        Carousel: ViewCarousel,
        List: ViewList
    },
    Presentation: {
        Start: DesktopWindows,
        Cancel: DesktopAccessDisabled
    },
    Expand: {
        ExpandMore: ExpandMoreIcon,
        ExpandLess: ExpandLessIcon
    },
    Face: FaceIcon,
    PersonAdd: PersonAddIcon,
    AccountBox: AccountBoxIcon,
    Language,
    ExitToApp: ExitToAppIcon,
    Duplicate: FileCopyIcon,
    Add: AddIcon,
    ChatOutlinedIcon,
    Calendar,
    Schedule,
    Link,
    DragIndicator,
    Copy: FileCopyOutlined,
    Pen: Create,
    Send,
    Cancel,
    Error,
    Exit: ExitToApp,
    Notification: NotificationsNone,
    Person: PermIdentity,
    Invite: PersonAdd,
    Play: PlayArrow,
    Stop,
    Search,
    Draft,
    Share,
    Tiktok: TiktokIcon,
    IosShare: IosShareIcon,
    VideoCamera: VideocamOutlined,
    MusicNote: MusicNoteOutlined,
    Mic: MicNoneOutlined,
    MicFilled: MicOutlined,
    MicMuted,
    FullscreenOutlined,
    Close,
    Message,
    Warning,
    Delete,
    Cast,
    CastConnected,
    Emoji,
    Done,
    Receipt,
    Group,
    ThumbUp,
    VoiceOverOff,
    VoiceOver,
    Info,
    KeyboardArrowDown,
    Settings,
    Tune,
    GridOn,
    Reorder,
    InsertEmoticonIcon,
    Star,
    Stars,
    StarBorder: StarBorderIcon,
    Notifications: {
        Active: NotificationsActive,
        Inactive: NotificationsNone
    },
    PhoneIcon,
    RadioButtonCheckedIcon,
    KvixKoin,
    ViewAgenda,
    Publish,
    Block,
    EmailIcon,
    DurationIcon,
    EquipmentIcon
};
//# sourceMappingURL=icons.js.map